import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResourceService } from './resource';
import { CacheService } from '../cache';
import { Resource } from '../../models/resource';

@Injectable({
  providedIn: 'root',
})
export class PreferenceService extends ResourceService<Resource> {
  constructor(protected http: HttpClient, protected cache: CacheService) {
    super(http, cache, 'businesses');
  }

  /**
   * 1. Get Preference By ID
   * GET /businesses/preference/:id
   * @param id ID of the preference
   */
  getPreferenceById(id: string): Observable<any> {
    return this.http.get<any>(`${this.endpoint}/preference/${id}`).pipe(
      map((resp: any) => resp)
    );
  }

  /**
   * 2. Get Preferences
   * GET /businesses/:id/preference
   * @param id ID of the business
   */
  getPreferences(id: string): Observable<any> {
    return this.http.get<any>(`${this.endpoint}/${id}/preference`).pipe(
      map((resp: any) => resp)
    );
  }

  /**
   * Alias for getPreferences
   * GET /businesses/:id/preference
   * @param id ID of the business
   */
  getPreference(id: string): Observable<any> {
    return this.getPreferences(id);
  }

  /**
   * 3. Save Business Preference
   * POST /businesses/:id/preference
   * @param id ID of the business
   * @param payload Business preference data
   */
  saveBusinessPreference(id: string, payload: any): Observable<any> {
    return this.http.post<any>(`${this.endpoint}/${id}/preference`, payload).pipe(
      map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        return resp;
      })
    );
  }

  /**
   * Alias for saveBusinessPreference
   * POST /businesses/:id/preference
   * @param id ID of the business
   * @param payload Business preference data
   */
  savePreference(id: string, payload: any): Observable<any> {
    return this.saveBusinessPreference(id, payload);
  }
}
